import gql from 'graphql-tag';
import { LOGISTIC_FORWARDER } from './fragments';

export const CREATE_FRIGHTS = gql`
  
mutation createFreights($input: [CreateFreightInput!]!) {
    createFreights(input: $input) {
      
        comment
        cost
        costCurrency
        costVolume
        firstValidityDate
        incoterm
        lastValidityDate
        logisticForwarder
        logisticMaterial
        portOfDestination
        portOfLoading
        qualityGroup
        shippingLine
        thcAdminCost 
          {
            currency
            precision
            quantity
            volume
          }        
    }
  }
`;

export const GET_LOGISTIC_FORWARDER = gql`
  ${LOGISTIC_FORWARDER}
  query filteredProviders($input: FilteredProvidersInput!) {
    filteredProviders(input: $input) {
      ...provider
    }
  }
`;
